import PubSub from "pubsub-js";
import OverlayScrollBars from "overlayscrollbars/js/jquery.overlayScrollbars.js";
import gsap from 'gsap';

var ModalFormResponse = function(options) {

	this.options = {
		$el: false,
		baseClass: 'comp-ModalFormResponse',
	};

	$.extend(true, this.options, options);

};

ModalFormResponse.prototype.init = function() {

	var self = this;



	this.$modal = this.options.$el.find(`.${self.options.baseClass}__modal`);
	this.$modalContent = this.$modal.find(`.${self.options.baseClass}__modalContent`);
	this.$closeXSpans = self.options.$el.find(`.${self.options.baseClass}__closeX span`);
	this.$button = self.options.$el.find(`.${self.options.baseClass}__button`);
	this.$buttonLink = this.$button.find(`.atom-ButtonPrimary`);

	this.formHandle = self.options.$el.data('formHandle');

	$('form').on('onAfterFormieSubmit', function(e) {

		let data = e.detail;

		let submittedFormHandle = $(e.target).data('config').formHandle;

		if (submittedFormHandle == self.formHandle) {

			/*
			In this spot, if form submitted was the ebrochure form, then
			we will send an ajax request to get the PDF URL for the ebrochure,
			(using the values from the entries field)
			and on success we will close the ebrochure modal and open this with
			the button url populated appropriately.
			Also, the ebrochure modal should go to a loading state when the form
			is submitted.
			*/
			
			// for e-brochure form
			if (submittedFormHandle == 'eBrochure' && self.formHandle == 'eBrochure') {
				let checkedPlanIds = [];

				PubSub.publish('ModalEBrochure:close');
				self.buttonLoading();
				self.showButton();
				self.open();

				$(e.target).find(`[name="fields[interestedIn][]"]:checked`).each(function() {
					checkedPlanIds.push($(this).val());
				});

				$.ajax({
					url: '/ajax/getFloorPlanPdfUrl',
					data: {
						floorPlanIds: checkedPlanIds
					},
					success: function(data) {
						self.$buttonLink.attr('href', data);
						self.$buttonLink.attr('target', '_blank');

						if (self.$buttonLink.html() == '') {
							self.$buttonLink.html('Download Now');
						}

						self.buttonNotLoading();
						
					},
					error: function() {
						console.log('ajax error');
					}
				});

			}

			// for apply now form, set apply link in button
			else if (submittedFormHandle == 'applyNowForm' && self.formHandle == 'applyNowForm') {
				let applyNowUrl = $(e.target).find(`[name="fields[applyUrl]"]`).val();

				self.showButton();
				self.$buttonLink.attr('href', applyNowUrl);
				self.$buttonLink.attr('target', '_blank');
				
				if (self.$buttonLink.html() == '') {
					self.$buttonLink.html('Apply Now');
				}

				self.open();

			}
			else {
				self.open();
			}

			// close the unit detail modal if it is open
			PubSub.publish('ModalUnitDetail:close');

		}

	});

	this.initAnimationTimelines();

	this.options.$el.find(`.${self.options.baseClass}__closeX`).on('click', function(e) {

		e.stopPropagation(); // prevent our overlay background click event from triggering the fast close timeline
		self.close();

	});

	this.options.$el.on('click', function() {

		self.fastClose();

	});

	this.$modal.on('click', function(e) {

		e.stopPropagation();

	});

	// pubsub events
	PubSub.subscribe('ModalFormResponse:open', function() {

		self.open();

	});

	PubSub.subscribe('ModalFormResponse:close', function() {
	    
		self.close();

	});

};


ModalFormResponse.prototype.showButton = function() {

	let self = this;

	self.$button.addClass(`${self.options.baseClass}__button--visible`);

};

ModalFormResponse.prototype.hideButton = function() {

	let self = this;

	self.$button.removeClass(`${self.options.baseClass}__button--visible`);

};

ModalFormResponse.prototype.buttonLoading = function() {

	let self = this;

	this.$buttonLink.addClass(`atom-ButtonPrimary--loading`);

};

ModalFormResponse.prototype.buttonNotLoading = function() {

	let self = this;

	this.$buttonLink.removeClass(`atom-ButtonPrimary--loading`);

};

ModalFormResponse.prototype.initAnimationTimelines = function() {

	var self = this;

	this.openTimeline = gsap.timeline(
		{
			paused: true,
			// repeat: -1
		}
	)
	.add(function() {
		// self.overlayScrollbarsInstance.scroll([ 0, 0 ]);
	})
	// .set(self.$modalContent,
	// 	{
	// 		opacity: 0,
	// 		scale: 0.95,
	// 	}
	// )
	.set(self.options.$el,
		{
			visibility: 'visible',
			zIndex: 2001,
		}
	)
	.to(self.options.$el,
		{
			duration: 0.45,
			ease: "power1.out",
			opacity: 1,
		}
	)
	.to(self.$modal,
		{
			duration: 0.45,
			ease: "power1.out",
			opacity: 1,
			y: 0,
		},
		"<"
	)
	// .to(self.$modalContent,
	// 	{
	// 		duration: 0.45,
	// 		ease: "power1.out",
	// 		opacity: 1,
	// 		scale: 1,
	// 	},
	// 	">-0.3"
	// )
	// close x
	.from(self.$closeXSpans,
		{
			duration: 0.25,
			width: 0,
			ease: "power3.out"
		}
	)
	.from(self.$closeXSpans,
		{
			duration: 0.25,
			rotate: 0,
			ease: "power1.inOut"
		},
		">-0.1"
	);

	// close
	this.closeTimeline = gsap.timeline(
		{
			paused: true,	
		}
	)
	.to(self.$closeXSpans,
		{
			duration: 0.25,
			rotate: 0,
			ease: "power1.inOut"
		}
	)
	.to(self.$closeXSpans,
		{
			duration: 0.25,
			width: 0,
			ease: "power3.in"
		},
		">-0.1"
	)
	.to(self.options.$el,
		{
			duration: 0.45,
			ease: "power1.out",
			opacity: 0,
		},
		">-0.1"
	)
	.set(self.options.$el,
		{
			visibility: 'hidden',
			zIndex: -1,
		}
	);

	// fast close
	this.fastCloseTimeline = gsap.timeline(
		{
			paused: true,	
		}
	)
	.to(self.options.$el,
		{
			duration: 0.45,
			ease: "power1.out",
			opacity: 0,
		},
		">-0.1"
	)
	.set(self.options.$el,
		{
			visibility: 'hidden',
			zIndex: -1,
		}
	);

};

ModalFormResponse.prototype.open = function() {

	var self = this;

	// scrollbars need to be shown/hidden via css class, because they are added dynamically via third-party plugin
	self.options.$el.removeClass(`${self.options.baseClass}--showScrollbars`);

	this.openTimeline.restart();

	this.startLoadTime = Date.now();

};

ModalFormResponse.prototype.close = function() {

	this.closeTimeline.restart();

};

ModalFormResponse.prototype.fastClose = function() {

	this.fastCloseTimeline.restart();

};

export default ModalFormResponse;
